import { useQuery } from '../services/NetworkManager';
import { NetworkManager } from '../services';

export function getProfile() {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.getPartnerWithReferral,
  });
}

export default function useGetPartnerProfile() {
  const { data, isLoading, isFetchedAfterMount } = useQuery(`${['getPartner']}`, getProfile);

  return { data, isLoading, isFetchedAfterMount };
}

export const getCreateP2PPaymentLink = ({
  clientPublicId,
  amount,
  investmentType,
  totalProjectedValue,
  returns,
  payoutDate,
}: any) => {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.generateUserP2PPaymentLink,
    data: {
      clientPublicId: clientPublicId,
      amount: amount,
      investmentType: investmentType,
      totalProjectedValue: totalProjectedValue,
      returns: returns,
      payoutDate: payoutDate,
    },
  });
};

export const getCreateWalletPaymentLink = ({ clientPublicId, amount }: any) => {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.generateUserWalletPaymentLink,
    data: {
      clientPublicId,
      amount,
    },
  });
};

export const getCreateMIFPaymentLink = ({
  dealId,
  clientPublicId,
  amount,
  reinvestmentOn,
  isMulti,
}: {
  dealId: string;
  clientPublicId: string;
  amount: number | string;
  reinvestmentOn: boolean;
  isMulti: boolean;
}) => {
  return NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.generateUserMIFPaymentLink,
    data: {
      dealId,
      clientPublicId,
      reinvestmentOn,
      amount,
      isMulti,
    },
  });
};

export const getPgVaWalletBalance = ({ amount }) => {
  return NetworkManager.Call({
    method: 'get',
    path: NetworkManager.PATH.pgVaBalanceCheck.replace('{{amount}}', amount),
  });
};
